export default __webpack_public_path__ + "static/media/srinagar3.322931ff.jpg";